/**
 * Custom hook for profile-related events
 * Centralizes event management for onboarding steps
 */

import { useEffect } from 'react';

export type ProfileEvent = 
  | 'subjectsUpdated'
  | 'paymentCompleted'
  | 'profileUpdated';

/**
 * Dispatch a profile event
 */
export function dispatchProfileEvent(event: ProfileEvent, data?: any) {
  window.dispatchEvent(new CustomEvent(event, { detail: data }));
}

/**
 * Listen to profile events
 */
export function useProfileEvent(
  event: ProfileEvent,
  handler: (data?: any) => void,
  deps: any[] = []
) {
  useEffect(() => {
    const wrappedHandler = (e: Event) => {
      const customEvent = e as CustomEvent;
      handler(customEvent.detail);
    };

    window.addEventListener(event, wrappedHandler);

    return () => {
      window.removeEventListener(event, wrappedHandler);
    };
  }, [event, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
}

